// extracted by mini-css-extract-plugin
export var dividerLine = "_41-0";
export var errorBackground = "_41-1";